export default __webpack_public_path__ + "static/media/Laura-Matt-testimonial.f2195d89.jpg";